import React, {useEffect, useState} from 'react';
import {CircularProgress, Button, FormControl, Select, MenuItem, Box, Grid, Paper, Table, TableBody, TableContainer, Typography, InputAdornment, TextField, TableHead, TableRow, TableCell, IconButton, styled} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import ActivityRowData from "./activity-row-data.component";
import useFilters from "../../hooks/useFilters";
import useActivityLogs from "../../hooks/useActivityLogs";
import DateRangePickerComponent from "../common/CustomDateRangePicker";
import moment from "moment";
import ActivityLogsSkeleton from "../reports/report-logs/skeleton/report-logs-list.skeleton"; 
import CachedIcon from "@mui/icons-material/Cached";
import DownloadIcon from "@mui/icons-material/Download";
import {useSnackbar} from "notistack";

const activityLogsTableHeaders = [
    {label: "Email"},
    {label: "User Type"},
    {label: "Module"},
    {label: "Action"},
    {label: "Activity"},
    {label: "Timestamp"}
]

const SmallSelect = styled(Select)(({theme, fontColor}) => ({
    minWidth: 120,  
    height: 33,    
    fontSize: "0.875rem",  
    ".MuiSvgIcon-root": {
        color: fontColor,
    },
    color: fontColor,
    backgroundColor: '#fff',
    border: "1px solid #7A78F7",
    "& .MuiInputBase-root": { 
        height: 33, 
        border: "1px solid #7A78F7", 
        color: "#3333CFCE", 
        backgroundColor: "#fff", 
        width: 250, 
        borderRadius: "5px" 
    },
    "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "& .MuiOutlinedInput-input" : {
        paddingRight: "0px !important"
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "& .MuiSelect-select": {
        fontSize: 12,
        fontStyle: "italic"
    },
    "& .MuiMenuItem-root": {
        fontSize: 12,
    },
    "& .Mui-selected": {
        fontSize: 12,
        fontStyle: "italic"
    }
}));

const ActivityLogsListComponent = () => {

    const {enqueueSnackbar} = useSnackbar();
    const {isFetchingLogList, activityLogsList, listActivityLogs, isExportActivityLogs, exportActivityLogs} = useActivityLogs();
    const {emailList, moduleList, getUserEmail, getModule} = useFilters();


    const [startDate, setStartDate] = useState(moment().subtract(6, 'days').format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

    const [searchedEmail, setSearchedEmail] = useState("");
    const [searchedModule, setSearchedModule] = useState("");
    const [searchedAction, setSearchedAction] = useState("");
    const [toggleEmailSearch, setToggleEmailSearch] = useState(false);
    const [toggleModuleSearch, setToggleModuleSearch] = useState(false);
    const [toggleActionSearch, setToggleActionSearch] = useState(false);


    useEffect(() => {
        getModule();
        getUserEmail();
    }, [])

    useEffect(() => {
        if (toggleEmailSearch && searchedEmail && (!toggleModuleSearch && !searchedModule) && (!toggleActionSearch && !searchedAction)) {
            let payload = {
                start_date: startDate,
                end_date: endDate,
                email: [searchedEmail?.user_email],
                filter_type: 2,
            }

            listActivityLogs(payload);

        } else if (toggleModuleSearch && searchedModule && (!toggleEmailSearch && !searchedEmail) && (!toggleActionSearch && !searchedAction)) {
            let payload = {
                start_date: startDate,
                end_date: endDate,
                module: [searchedModule],
                filter_type: 3,
            }

            listActivityLogs(payload);

        } else if (toggleActionSearch && searchedAction  && (!toggleModuleSearch && !searchedModule) && (!toggleEmailSearch && !searchedEmail)) {
            let payload = {
                start_date: startDate,
                end_date: endDate,
                action: searchedAction,
                filter_type: 4,
            }

            listActivityLogs(payload);
        
        } else if (toggleEmailSearch && searchedEmail && toggleModuleSearch && searchedModule && (!toggleActionSearch && !searchedAction)) {
            let payload = {
                start_date: startDate,
                end_date: endDate,
                email: [searchedEmail?.user_email],
                module: [searchedModule],
                filter_type: 5,
            }

            listActivityLogs(payload);

        } else if (toggleEmailSearch && searchedEmail && toggleActionSearch && searchedAction && (!toggleModuleSearch && !searchedModule)) {
            let payload = {
                start_date: startDate,
                end_date: endDate,
                email: [searchedEmail?.user_email],
                action: searchedAction,
                filter_type: 6,
            }

            listActivityLogs(payload);
        
        } else if (toggleModuleSearch && searchedModule && toggleActionSearch && searchedAction && (!toggleEmailSearch && !searchedEmail)) {
            let payload = {
                start_date: startDate,
                end_date: endDate,
                module: [searchedModule],
                action: searchedAction,
                filter_type: 7,
            }

            listActivityLogs(payload);
        
        } else if (toggleEmailSearch && searchedEmail && toggleModuleSearch && searchedModule && toggleActionSearch && searchedAction) {
            let payload = {
                start_date: startDate,
                end_date: endDate,
                email: [searchedEmail?.user_email],
                module: [searchedModule],
                action: searchedAction,
                filter_type: 8,
            }

            listActivityLogs(payload);

        } else {
            let payload = {
                start_date: startDate,
                end_date: endDate, 
                filter_type: 1,
            }

            listActivityLogs(payload);
        }
    }, [startDate, endDate, toggleEmailSearch, searchedEmail, toggleModuleSearch, toggleActionSearch, searchedModule, searchedAction])


    const handleChangeUserEmail = (event) => {
        setSearchedEmail(event.target.value);
        setToggleEmailSearch(true);
    }

    const handleChangeModule = (event) => {
        setSearchedModule(event.target.value);
        setToggleModuleSearch(true);
    }

    const handleDateRangeChange = (newStartDate, newEndDate) => {
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    }

    const handleSearchAction = (e) => {
        setSearchedAction(e.target.value);
        setToggleActionSearch(true);

        // if (e.key === "Enter") {
        //     let payload = {
        //         start_date: startDate,
        //         end_date: endDate,
        //         action: searchedAction,
        //         filter_type: 4,
        //     }

        //     listActivityLogs(payload);
        // }
    }

    const handleClearInput = (e, name) => {
        if (name === "email") {
            setSearchedEmail("");
            setToggleEmailSearch(false);

        } else if (name === "module") {
            setSearchedModule("");
            setToggleModuleSearch(false);

        } else if (name === "action") {
            setSearchedAction("");
            setToggleActionSearch(false);
        }
    }

    const handleClearFilters = (e) => {
        setSearchedEmail("");
        setSearchedModule("");
        setSearchedAction("");
        setStartDate(moment().subtract(6, "days").format("YYYY-MM-DD"));
        setEndDate(moment().format("YYYY-MM-DD"));
    }

    const handleExport = (e) => {
        if (activityLogsList?.length > 0) {
            if (toggleEmailSearch && searchedEmail && (!toggleModuleSearch && !searchedModule) && (!toggleActionSearch && !searchedAction)) {
                let payload = {
                    start_date: startDate,
                    end_date: endDate,
                    email: [searchedEmail?.user_email],
                    filter_type: 2,
                }

                exportActivityLogs(payload);

            } else if (toggleModuleSearch && searchedModule && (!toggleEmailSearch && !searchedEmail) && (!toggleActionSearch && !searchedAction)) {
                let payload = {
                    start_date: startDate,
                    end_date: endDate,
                    module: [searchedModule],
                    filter_type: 3,
                }

                exportActivityLogs(payload);

            } else if (toggleActionSearch && searchedAction  && (!toggleModuleSearch && !searchedModule) && (!toggleEmailSearch && !searchedEmail)) {
                let payload = {
                    start_date: startDate,
                    end_date: endDate,
                    action: searchedAction,
                    filter_type: 4,
                }

                exportActivityLogs(payload);
            
            } else if (toggleEmailSearch && searchedEmail && toggleModuleSearch && searchedModule && (!toggleActionSearch && !searchedAction)) {
                let payload = {
                    start_date: startDate,
                    end_date: endDate,
                    email: [searchedEmail?.user_email],
                    module: [searchedModule],
                    filter_type: 5,
                }

                exportActivityLogs(payload);

            } else if (toggleEmailSearch && searchedEmail && toggleActionSearch && searchedAction && (!toggleModuleSearch && !searchedModule)) {
                let payload = {
                    start_date: startDate,
                    end_date: endDate,
                    email: [searchedEmail?.user_email],
                    action: searchedAction,
                    filter_type: 6,
                }

                exportActivityLogs(payload);
            
            } else if (toggleModuleSearch && searchedModule && toggleActionSearch && searchedAction && (!toggleEmailSearch && !searchedEmail)) {
                let payload = {
                    start_date: startDate,
                    end_date: endDate,
                    module: [searchedModule],
                    action: searchedAction,
                    filter_type: 7,
                }

                exportActivityLogs(payload);
            
            } else if (toggleEmailSearch && searchedEmail && toggleModuleSearch && searchedModule && toggleActionSearch && searchedAction) {
                let payload = {
                    start_date: startDate,
                    end_date: endDate,
                    email: [searchedEmail?.user_email],
                    module: [searchedModule],
                    action: searchedAction,
                    filter_type: 8,
                }

                exportActivityLogs(payload);

            } else {
                let payload = {
                    start_date: startDate,
                    end_date: endDate, 
                    filter_type: 1,
                }

                exportActivityLogs(payload);
            }

        } else {
            enqueueSnackbar("No data to export", { 
                variant: "error",
                autoHideDuration: 3000
            });
        }
    }


    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6" sx={{color: "#58565f", fontWeight: 600, fontSize: 20}}>
                        Activity Logs
                    </Typography>

                    <Typography variant="body1" sx={{color: "#58565fd4", fontSize: 14}}>
                        Summary of user activities
                    </Typography>
                </Grid>
            </Grid>

            <Box sx={{mt: 3}}>
                <Grid container>
                    <Grid item xs={3}>
                        <Button variant="contained" sx={{height: "33px", textTransform: "none", backgroundColor: "#5959D8", color: "#fff", "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}}
                            startIcon={<CachedIcon />} onClick={(e) => handleClearFilters(e)}
                        >
                            Clear Filters
                        </Button>
                    </Grid>

                    <Grid item xs={9} sx={{display: "flex", justifyContent: "flex-end", ml: "auto"}}>
                        <FormControl sx={{width: 250}}>
                            <SmallSelect
                                value={searchedEmail}
                                onChange={handleChangeUserEmail}
                                displayEmpty
                                fontColor={"#5d5ed8"}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <p style={{fontSize: 12, margin: 0, color: "#3333CFCE", fontWeight: "bold"}}>
                                            Email:
                                        </p>
                                    </InputAdornment>
                                }
                                endAdornment={searchedEmail && 
                                    (
                                        <InputAdornment position="end">
                                            <IconButton sx={{mr: "12px"}}
                                                size="small"
                                                onClick={(e) => handleClearInput(e, "email")}
                                            >
                                                <ClearIcon sx={{color: "#3333CFCE", fontSize: 16}} />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }
                            >
                                <MenuItem value="" disabled sx={{fontSize: 12}}>
                                    <em>Select Email</em>
                                </MenuItem>
                                
                                {emailList?.map((list, index) => {
                                    return (
                                        <MenuItem key={index} value={list} sx={{fontSize: 12}}>
                                            {list?.user_email}
                                        </MenuItem>
                                    )
                                })}
                            </SmallSelect>
                        </FormControl>

                        &nbsp;&nbsp;&nbsp;

                        <FormControl sx={{ width: 250 }}>
                            <SmallSelect
                                value={searchedModule}
                                onChange={handleChangeModule}
                                displayEmpty
                                fontColor={'#5d5ed8'}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <p style={{ fontSize: 12, margin: 0, color: "#3333CFCE", fontWeight: 'bold' }}>
                                            Module:
                                        </p>
                                    </InputAdornment>
                                }
                                endAdornment={searchedModule && 
                                    (
                                        <InputAdornment position="end">
                                            <IconButton sx={{mr: "12px"}}
                                                size="small"
                                                onClick={(e) => handleClearInput(e, "module")}
                                            >
                                                <ClearIcon sx={{color: "#3333CFCE", fontSize: 16}} />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }
                            >
                                <MenuItem value="" disabled sx={{fontSize: 12}}>
                                    <em>Select Module</em>
                                </MenuItem>
                                
                                {moduleList?.map((list, index)=>{
                                    return(
                                        <MenuItem key={index} value={list.module} sx={{fontSize: 12}}>
                                            {list.module}
                                        </MenuItem>
                                    )
                                })}
                            </SmallSelect>
                        </FormControl>

                        &nbsp;&nbsp;&nbsp;

                        <TextField
                            sx={{
                                "& .MuiInputBase-root": {height: 33, border: "1px solid #7A78F7", color: "#3333CFCE", backgroundColor: '#fff', width: "auto", borderRadius: "5px"},
                                "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                },
                            }}
                            variant="outlined"
                            autoComplete="off"
                            inputProps={{ style: { padding: "5px 12px 5px 0px", fontSize: 12, fontStyle: 'italic' }, border: "1px solid #7A78F7" }}
                            placeholder="Search Action"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <p style={{ fontWeight: 'bold', fontSize: 12, margin: 0, color: "#3333CFCE"}}>
                                            Action:
                                        </p>
                                    </InputAdornment>
                                ),
                                endAdornment: searchedAction && (
                                    <InputAdornment position="end">
                                        <IconButton
                                            size="small"
                                            onClick={(e) => handleClearInput(e, "action")}
                                        >
                                            <ClearIcon sx={{color: "#3333CFCE", fontSize: 17}} />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            value={searchedAction}
                            onChange={(e) => setSearchedAction(e.target.value)}
                            onKeyDown={handleSearchAction}
                        />

                        &nbsp;&nbsp;&nbsp;

                        <DateRangePickerComponent
                            initialStartDate={startDate}
                            initialEndDate={endDate}
                            ranges={{
                                "Last 7 Days": [moment().subtract(6, 'days'), moment()],
                                "This Month": [moment().startOf('month'), moment().endOf('month')],
                                "Last Month": [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                                "Last 90 Days": [moment().subtract(89, 'days'), moment()],
                            }}
                            onDateRangeChange={handleDateRangeChange}
                        />  

                        &nbsp;&nbsp;&nbsp;

                        <Button variant="contained" sx={{fontSize: 12, background: "#3333CFCE", color: "#fff", textTransform: "none", "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}}
                            startIcon= {isExportActivityLogs ? <CircularProgress sx={{color: "#fff"}} size={11} /> : <DownloadIcon />}
                            onClick={(e) => handleExport(e)}   
                        >
                            {isExportActivityLogs ? "Exporting" : "Export"}
                        </Button>    
                    </Grid>
                </Grid>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TableContainer component={Paper} sx={{borderRadius: 2, width: "100%", mt: 2, maxHeight: 750, overflow: "auto",
                        "&::-webkit-scrollbar": {
                            width: "6px",
                        },
                        "&::-webkit-scrollbar-track": {
                            background: "rgba(217, 217, 217, 0.5)"
                        },
                        "&::-webkit-scrollbar-thumb": {
                            background: "#7a78f7a6",
                            borderRadius: "4px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                            background: "#7A78F7",
                            
                        }}}
                    >
                        <Table stickyHeader aria-label="sticky table" sx={{minWidth: 650}}>
                            <TableHead sx={{border: "1px solid #3333cf54"}}>
                                <TableRow>
                                    {activityLogsTableHeaders?.map((header, index) => (
                                        <TableCell key={index} sx={{ fontWeight: 700, color: '#3333CFCE', backgroundColor: "#D8D8FD", borderTop: "1px solid #7A78F7",
                                            borderBottom: "1px solid #7A78F7", borderLeft: (index === 0) ? "1px solid #7A78F7" : {}, borderTopLeftRadius: (index === 0) ? "8px" : {},
                                            borderRight: (index === 5) ? "1px solid #7A78F7" : {}, borderTopRightRadius: (index === 5) ? "2px" : {}, textAlign: (header?.label == "Last Location") ? "center" : "left" 
                                        }}>
                                            {header.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            {(isFetchingLogList) ?
                                <TableBody sx={{maxHeight: "calc(100vh - 300px)", overflowY: "auto"}}>
                                    <ActivityLogsSkeleton />
                                
                                </TableBody>
                            :

                                <TableBody sx={{maxHeight: "calc(100vh - 300px)", overflowY: "auto"}}>
                                    {((activityLogsList?.length > 0) ?
                                        activityLogsList?.map((activity, index) => (
                                            <ActivityRowData activity={activity} index={index} />
                                        )) 
                                    :
                                        <TableRow sx={{'&:last-child td, &:last-child th': {border: 0}, '& td, & th': {borderBottom: 0}}}>
                                            <TableCell colSpan={6} align="center">
                                                <Typography sx={{fontSize: 16, color: "#58565f", padding: "40px 40px 20px 40px"}}>
                                                    No available data to display
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )} 

                                    <br/>
                                </TableBody>
                            }
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Box>
    )
}

export default ActivityLogsListComponent